import type { GridApi } from '@mui/x-data-grid-pro';
import type React from 'react';

export function expandAncestors(
  apiRef: React.RefObject<GridApi>,
  targetId: number,
): { found: boolean; expandedAny: boolean } {
  const api = apiRef.current;
  if (!api) return { found: false, expandedAny: false };

  const node = api.getRowNode(targetId);
  if (!node) return { found: false, expandedAny: false };

  const collapsedAncestors: Array<string | number> = [];
  let cursor = node.parent != null ? api.getRowNode(node.parent) : null;
  while (cursor && cursor.type === 'group') {
    if (!cursor.childrenExpanded) collapsedAncestors.push(cursor.id);
    cursor = cursor.parent != null ? api.getRowNode(cursor.parent) : null;
  }

  for (const ancestorId of collapsedAncestors) {
    api.setRowChildrenExpansion(ancestorId, true);
  }

  return { found: true, expandedAny: collapsedAncestors.length > 0 };
}
